import { useQuery } from '@apollo/client';

import { GetRecurringExportDocument } from './getRecurringExport.gql';

const useGetRecurringExport = (accountingRecurringExportId: string) => {
  const { data, ...hook } = useQuery(GetRecurringExportDocument, {
    skip: !accountingRecurringExportId,
    variables: { accountingRecurringExportId },
  });

  const recurringExport = data?.viewer.accountingRecurringExport;

  return { recurringExport, ...hook };
};

export type AccountingRecurringExport = NonNullable<
  ReturnType<typeof useGetRecurringExport>['recurringExport']
>;

export default useGetRecurringExport;
